import React, { useEffect, useState } from "react";
import { ILoyaltyCustomer, ILoyaltyProgram, IReward, ITier } from "redux/reducers/models/loyalty";
import "./loyaltyProgramRewards.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faStar } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import LoyaltyProgramPointsMeter from "./LoyaltyProgramPointsMeter";
import { IProduct, TProductType } from "redux/reducers/models/product";

interface IProps {
    tiers: Array<ITier>;
    rewards: Array<IReward & {products?: Array<IProduct>; product_types?: Array<TProductType>}>;
    customer: ILoyaltyCustomer;
    loyaltyProgram: ILoyaltyProgram;
}


export default function LoyaltyProgramRewards(props: IProps) {
    const {tiers, rewards, customer, loyaltyProgram} = props;
    const {t} = useTranslation();
    const [sortedTiers, setStortedTiers] = useState<Array<ITier>>([]);

    useEffect(() => {
        if (tiers) {
            const sortedTiers = tiers?.sort((a,b) => a.points_required - b.points_required);
            rewards?.sort((a,b) => a.points_required - b.points_required);
            setStortedTiers(sortedTiers);
        }
    }, [tiers]);

    return (
        <div>
            {loyaltyProgram?.type === "tier_based" && tiers?.length > 0 ? (
                <LoyaltyProgramPointsMeter
                    tiers={tiers}
                    customer={customer}
                    />
            ) : null}
            <br />
            <h1>{loyaltyProgram?.type === "tier_based" ? t("Tier Benefits") : t("Rewards")}</h1>
            <br />
            {loyaltyProgram?.type === "tier_based" ? (
            <div className="loyalty-program-rewards-cards-container">
                {sortedTiers?.map((tier, index) => {
                    return (
                        <div key={index} className="loyalty-program-rewards-card">
                            <div className="loyalty-program-rewards-card-top">
                                <div className="loyalty-program-rewards-card-icon">
                                    <div><FontAwesomeIcon icon={faStar} /></div>
                                </div>
                                <p className="loyalty-program-rewards-card-name">{tier?.title}</p>
                                <p className="loyalty-program-rewards-card-points">{tier?.points_required} {t("Pts")}</p>
                            </div>
                            <div className="loyalty-program-rewards-card-bottom">
                                {rewards?.filter(reward => reward?.loyalty_program_tier_id === tier?.id)?.map((reward, index) => {
                                    return (
                                        <div key={index} className="loyalty-program-rewards-card-row">
                                            <div className={"loyalty-program-rewards-card-row-icon"}>
                                                <FontAwesomeIcon icon={faCheck} />
                                            </div>
                                            <p>{reward?.name}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
            ) : (
                <div className="loyalty-program-rewards-cards-container">
                    {rewards?.map((reward, index) => {
                        return (
                                <div key={index} className="loyalty-program-rewards-card">
                                     <div className="loyalty-program-rewards-card-top">
                                        <div className="loyalty-program-rewards-card-icon">
                                            <div><FontAwesomeIcon icon={faStar} /></div>
                                        </div>
                                        <p className="loyalty-program-rewards-card-name">{reward?.name}</p>
                                        <p className="loyalty-program-rewards-card-points">{reward?.points_required} {t("Pts")}</p>
                                    </div>
                                    {reward?.products?.length > 0 ? (
                                             <div className="loyalty-program-rewards-card-bottom">
                                             {reward?.products?.map((product, index) => {
                                                 return (
                                                     <div key={index} className="loyalty-program-rewards-card-row">
                                                         <div className={"loyalty-program-rewards-card-row-icon"}>
                                                             <FontAwesomeIcon icon={faCheck} />
                                                         </div>
                                                         <p>{product?.preferred_title ? product?.preferred_title : product?.title}</p>
                                                     </div>
                                                 );
                                             })}
                                         </div>
                                    ) : reward?.product_types?.length > 0 ? (
                                        <div className="loyalty-program-rewards-card-bottom">
                                        {reward?.product_types?.map((type, index) => {
                                            return (
                                                <div key={index} className="loyalty-program-rewards-card-row">
                                                    <div className={"loyalty-program-rewards-card-row-icon"}>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </div>
                                                    <p>{type?.title}</p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    ) : null}
                                   
                                </div>
                        );
                    })}
                </div>
            )}
            <br />
        </div>
    );
}   